import { useDispatch, useSelector } from "react-redux"
import { State } from "../reducers"
import { REGEX_EMAIL, REGEX_LETRAS_ESPACIOS,REGEX_LETRAS_ESPACIOS_NUMS_PUNTOS, REGEX_NIT, REGEX_NRC } from "../constants/Regex"
import * as http from '../api/http'
import { ENDPOINTS } from "../api/config"
import { KEYS } from "../constants/keysStorage"
import { generalOpenConfirmEdit, generalOpenModalError, generalOpenModalInfo, generalOpenModalMessage, generalOpenToastError, generalOpenToastInfo, generalOpenToastSuccess, generalShowLoader, getFechaHora } from "./general.actions"
import { useEffect } from "react"

import FlechaDerechaIcon from '../media/felsv/white_right-arrow_icon.svg'
import EmitirIcon from '../media/felsv/white_check_icon.svg'
import MasOpcionesIcon from '../media/felsv/WhiteOpciones.svg'
import { getEmailNotifyMsg, unirChipsJoin, unirChipsReturnFirst, validarRegexLetras, validarRegexNumericoFloat2Decimales, validaRegexNumericoFloatNDecimales, validarRegexNumericoInt } from "../utils/strings.utils"
import { getMunicipios } from "./catalogos.actions"
import { facturacionGetUUID } from "./facturacion/facturacionEmision.actions"
import { convertDateFormatAnular, getFechaFormato1 } from "../utils/stringDate"
import { anularFactura, anularFactura_DTE, generateQRImageFromBits, getExcelFactura, getFacturaImage, getFacturaPDF_New, getQR, descargarJson, sendEmailPDF } from "./operaciones/operaciones.actions"
import { useHistory } from "react-router-dom"
import { OPSendEmail } from "../interfaces/operaciones.interface"
import { ActionCF, CFProducto } from "../interfaces/credito-fiscal.interfaces"
import { CREDITO_FISCAL_TYPES } from "../constants/credito-fiscal.types"
import { docsAsociadosReset, docsDatosReceptorSiguienteDispatch } from "./documentos/documentos.actions"
import { docsAsociadosItems } from "../pages/EmitirFactura/Components/GeneracionFactura/OtrosDocAsociados"
import { showMessageSucursalVacia } from "./userLogin.actions"
import { handleRestartStateFormaPago } from "./forma-pago.actions"
import useUtilsDocs, { formatearNum, getDigitosCalculables,isEmpresa3Digitos } from "./utils-documentos.actions"

export default function useCreditoFiscal (){
    const dteCode = "03";
    const nitTipoDoc = "36";

    const {formCliente, formProducto, formClienteFeles, errorsCliente, errorsProducto, errorsClienteFeles, productos, view, productoEdit, productoIndex, response_Emitir, clienteEncontrado, retencionRenta: quitarRetencionRenta, notasRemisionAsociadas} = useSelector((state: State) => state.creditoFiscal)
    const {departamentos, actividadesEconomicas, datosEmisor, unidadesMedida, tipoCargosMembresia} = useSelector((state: State) => state.catalogos)
    const {pagoCompletado, formFormaPago, pagos} = useSelector((state: State) => state.formaPago)
    const {datosUUID} = useSelector((state: State) => state.facturacion)
    const {datos} = useSelector((state: State) => state.userLogin)
    const {dataDocsAsociados} = useSelector((state: State) => state.documentos.otrosDocumentosAsociados);
    const datosReceptor = useSelector((state: State) => state.documentos.datosReceptor.form);

    const propinaConfig = useSelector((state: State) => state.userLogin.propina);

    const emisorGranContribuyente = datosEmisor?.tipoContribuyente === '1'
    const emisorJuridico = datosEmisor?.tipoEmpresa === '1'
    const dispatch = useDispatch()
    const history = useHistory()

    const {processFormCatalogoProducto, processOtrosImpuestosCalculo, procesOtrosImpuestosResumen} = useUtilsDocs();

    const cargarDatosIniciales = () => {
        let fechaActual = new Date().toISOString().split('T')[0]
        let sucursalConDocumento = formCliente?.datosSucursal?.find((suc: any) => suc.Documento.find((doc: any) => doc.iddocumento === '3'))
        let documentoSucursal = sucursalConDocumento?.Documento.find((doc: any) => doc.iddocumento === '3')

        dispatch(handleSetFormCliente({
            ...formCliente,
            fecha: fechaActual,
            sucursal: sucursalConDocumento?.idsucursal,
            serie: documentoSucursal?.idsucursaldocumento
        })) 
    }

    const onChangeFormCliente = (field: string, value: any) => {
        if(!validateChange(field, value) && value.trim() !== '') return
        dispatch(handleSetFormCliente({...formCliente, [field] : value}))
        validateFormCliente(field, value)
    }

    const onChangeFormProducto = (field: string, value: any, extraData = {}) => {
        if(!validateChange(field, value) && value.trim() !== '') return
        dispatch(handleSetFormProducto({...formProducto, ...extraData, [field] : value}))
        validateFormProducto(field, value)
    }

    const onChangeSelectCatalogoProducto = (codeProduct: string) => {
        const newFormProducto = processFormCatalogoProducto(dteCode, formProducto, codeProduct)
        dispatch(handleSetFormProducto({...formProducto, ...newFormProducto}))
        validateFormProducto('descripcion', codeProduct);
    }

    const onChangeFormClienteFeles = (field: string, value: any) => {
        if(!validateChange(field, value) && value.trim() !== '') return

        if (field === 'tipoTransaccion') {
            dispatch(handleSetFormClienteFeles({
                ...formClienteFeles,
                tipoTransaccion: value,
                valorTransaccion: '', documento: '', idBanco: '', numAutorizacion: '',
            }))
            localStorage.setItem(KEYS.COMPROBANTE, '');
        } else {
            dispatch(handleSetFormClienteFeles({...formClienteFeles, [field] : value}))
        }
       
        validateFormClienteFeles(field, value)
    }

    const validateFormCliente = (field: string, value: string) => {
        let message = ''
        switch (field) {
            case 'nombre':
                if(!value || value.trim() === ''){message = 'Nombre es requerido'; break;}         
                break;
            case 'noDocumento':
                if(!REGEX_NIT.test(value) && value.trim() !== '') {message = 'Formato de NIT incorrecto'; break}
                break;
            case 'departamento':
                if(!value || value.trim() === ''){message = 'Departamento es requerido.'}
                if(value && value !== '' && value !== formCliente.departamento){
                    let nombreDepartamento = departamentos.find(departamento => departamento.codigo === value)?.valor

                    if(nombreDepartamento){
                        dispatch(getMunicipios(parseInt(value), nombreDepartamento, true))
                        dispatch(handleSetFormCliente({...formCliente, departamentoDescripcion: nombreDepartamento, municipio: '', departamento: value}))
                    }
                }
                break;
            case 'municipio':
                if(!value || value.trim() === ''){message = 'Municipio es requerido.'}
                break;
            case 'direccion':
                if(!value || value.trim() === ''){message = 'Dirección es requerida.'}
                break;
            case 'email':
                const chipsEmail = formCliente.chipsEmail?.length || 0;
                if (chipsEmail <= 0 && (!value || value.trim() === '')){message = 'Correo electrónico es requerido.'; break;}
                if (value.trim() !== "" && !REGEX_EMAIL.test(value)) {message = 'Correo electrónico inválido'; break;}
                break;
            case 'telefono':
                if(!value || value.trim() === ''){message = 'Teléfono celular es requerido.'; break;}
                if(value.trim().length < 11){message = 'Teléfono celular inválido.'; break;}
                break;
            case 'actividad':
                if(!value || value.trim() === ''){message = 'Actividad económica es requerida.'; break;}
                break;
            case 'nrc':
                if((!value || value.trim() === '') && formCliente.tipoDocumento === nitTipoDoc){message = 'NRC es requerido.'; break;}
                if(!REGEX_NRC.test(value) && value.trim() !== ''){message = 'Formato de NRC incorrecto.'}
                break;
            case 'sucursal':
                if(!value || value === ''){message = 'Sucursal es requerida'}
                break;
            case 'serie':
                if(!value || value === ''){message = 'Serie es requerida'}
                break;
        }

        dispatch(handleErrorsFormCliente({
            ...errorsCliente,
            [field] : message
        }))

        return (message)
    }

    const validateFormClienteFeles = (field: string, value: string) => {
        let message = ''
        switch (field) {
            case 'valorTransaccion':
                if(!value || value.trim() === ''){message = 'Valor requerido'; break;}         
                break;
            case 'idBanco':
                if(!value){message = 'El banco es requerido'; break;}         
                break;
            case 'numAutorizacion':
                if(!value || value.trim() === ''){message = 'El número de autorización es requerido'; break;}         
                break;
            case 'documento':
                if(!value || value.trim() === ''){message = 'El comprobante es requerido'; break;}         
                break;
                break;
        }

        dispatch(handleErrorsFormClienteFeles({
            ...errorsClienteFeles,
            [field] : message
        }))

        return (message)
    }

    const setErrorsFormClienteFeles = (errors: any) => {
        dispatch(handleErrorsFormClienteFeles({
            ...errorsClienteFeles,
            ...errors,
        }))
    }

    const validateFormProducto = (field: string, value: string) => {
        let message = ''
        
        switch(field){
            case 'descripcion':
                if(value.trim() === ''){message = 'Descripción es obligatoria.'; break;}
                break;
            case 'cantidad':
                if(value.trim() === '' || parseFloat(value) === 0){message = 'La cantidad debe ser mayor a 0.'; break;}
                break;
            case 'precio':
                if(value.trim() === '' || parseFloat(value) < 0){message = 'El precio debe ser mayor a 0.'; break;}
                break;
            case 'descuento':
                let suma = parseFloat(formProducto.cantidad) * parseFloat(formProducto.precio)
                if(parseFloat(value) > 100 && formProducto.tipoDescuento === 'Porcentaje') {message = 'El porcentaje de descuento no puede ser mayor al 100%.'; break;}
                if(formProducto.tipoDescuento === 'Monto'){
                    if(parseFloat(value) > suma){message = 'El monto de descuento no puede ser mayor al precio.'; break;}
                }
                break;
        }
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            [field] : message
        }))

        return (message)
    }

    const validateFormProductoEdit = (field: string, value: string) => {
        let message = ''
        
        switch(field){
            case 'descripcion':
                if(value.trim() === ''){message = 'Descripción es obligatoria.'; break;}
                break;
            case 'cantidad':
                if(value.trim() === '' || parseFloat(value) === 0){message = 'La cantidad debe ser mayor a 0.'; break;}
                break;
            case 'precio':
                if(value.trim() === '' || parseFloat(value) < 0){message = 'El precio debe ser mayor a 0.'; break;}
                break;
            case 'descuento':
                let suma = parseFloat(productoEdit.cantidad) * parseFloat(productoEdit.precio)
                if(parseFloat(value) > 100 && productoEdit.tipoDescuento === 'Porcentaje') {message = 'El porcentaje de descuento no puede ser mayor al 100%.'; break;}
                if(productoEdit.tipoDescuento === 'Monto'){
                    if(parseFloat(value) > suma){message = 'El monto de descuento no puede ser mayor al precio.'; break;}
                }
                break;
        }
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            [field] : message
        }))

        return (message)
    }

    const validateChange = (field: string, value: string) => {
        switch(field){
            case 'nombre':
                return (REGEX_LETRAS_ESPACIOS_NUMS_PUNTOS.test(value))
            case 'descripcion':
                    return validarRegexLetras(value);
            case 'cantidad':
                if(isEmpresa3Digitos(datos?.codigo_empresa))
                    return validaRegexNumericoFloatNDecimales(value);
                return validarRegexNumericoFloat2Decimales(value);
            case 'precio':
                    if(parseFloat(value) > 100000000000) return
                    if(isEmpresa3Digitos(datos?.codigo_empresa))
                        return validaRegexNumericoFloatNDecimales(value);
                    return validarRegexNumericoFloat2Decimales(value);
            case 'descuento':
                    if(parseFloat(value) > 100000000000) return
                    if(isEmpresa3Digitos(datos?.codigo_empresa))
                        return validaRegexNumericoFloatNDecimales(value);
                    return validarRegexNumericoFloat2Decimales(value);
            case 'noDocumento':
                if(value.length > 14) return false
                return(validarRegexNumericoInt(value))            
            case 'nrc':
                return (!(value.length > 7))
            default:
                return true
        }
    }

    const cargarSucursales = async() => {
        const newFormCliente = { ...formCliente, datosSucursal: [], loadedSucursal: true };

        try {
            let message = 'No se logró obtener el catalogo de sucursales'
            const response: any = await api_getSucursales({
                idsucursal: `${datos.sucursal_seleccionada}`,
                tipodocumento: '03'
            })

            if (response.body && !response.message) {
                const sucursal = response.body;
                const hayDocs = sucursal[0]?.Documento?.length;

                if (hayDocs) {
                    newFormCliente.datosSucursal = sucursal;
                }
                dispatch(handleSetFormCliente(newFormCliente));
            } else {
                dispatch(generalOpenModalError(response.message || message))
            }
        } catch (error: any) {
            if(error?.response?.data?.errorCode === 1) { dispatch(handleSetFormCliente(newFormCliente)); return; }
            dispatch(generalOpenModalError(error?.response?.data?.message ?? 'Error al obtener las sucursales', error?.response?.data?.status))
        }
    }

    const button_onClickAgregarProducto = () => {
        if(notasRemisionAsociadas.length > 0){
            dispatch(generalOpenModalInfo('No es posible agregar productos cuando hay una nota de remisión asociada.'))
            return
        }

        let errors: { [key: string]: string } = {};

        Object.keys(formProducto).forEach((key) => {
            if (validateFormProducto(key, formProducto[key])){
                let propiedad = key
                let value = validateFormProducto(key, formProducto[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            ...errors
        }))

        if(Object.values(errors).some((err) => err !== '')){
            dispatch(generalOpenModalInfo('Revisa el formulario de producto'))
            return;
        }

        let tempArray = productos
        tempArray.push(formProducto)
        dispatch(handleAddProducto(tempArray))
        dispatch(generalOpenModalInfo('Producto agregado correctamente.'))
        dispatch(handleRestartFormProducto())
    }

    const button_onClickLimpiarFormProducto = () => {
        dispatch(handleRestartFormProducto())
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            descripcion: '',
            cantidad: '',
            precio: '',
            descuento: ''
        }))
    }

    const footer_onClickNext = async() => {
        switch (view) {
            case 'Formularios':
                let errors: { [key: string]: string } = {};

                Object.keys(formCliente).forEach((key) => {
                if (validateFormCliente(key, formCliente[key])){
                        let propiedad = key
                        let value = validateFormCliente(key, formCliente[key])
                        errors[propiedad] = value
                    }
                })
                dispatch(handleErrorsFormCliente({
                    ...errorsCliente,
                    ...errors
                }))

                if(Object.values(errors).some((err) => err !== '')){
                    dispatch(generalOpenModalInfo('Revisa los datos del formulario de cliente.'))
                    return;
                }

                if(productos.length === 0){
                    dispatch(generalOpenModalInfo('Debes agregar al menos un producto para continuar.'))
                    return;
                }

                const datosReceptor:any = dispatch(docsDatosReceptorSiguienteDispatch())
                if(datosReceptor === true) return;

                if(calculosProductos().total >= 2147483647){
                    dispatch(generalOpenToastError('Las operaciones que intentas realizar estàn fuera del lìmite permitido'))
                    return;
                }

                if(!pagoCompletado){
                    dispatch(generalOpenModalInfo('El monto total de pago debe ser igual al total a pagar'))
                    return
                }

                try {
                    dispatch(generalShowLoader(true))
                    await Promise.all([
                        dispatch(facturacionGetUUID('03', false))
                    ])
                } finally {
                    dispatch(generalShowLoader(false))
                }
                dispatch(handleChangeView('Previsualizacion'))
                break;
            case 'Previsualizacion':
                dispatch(handleActiveModalEmitir(true))
                break;
            case 'Detalle':
                dispatch(handleActiveModalMasOpciones(true))
                break;
        }
    }

    const footer_onClickBack = () => {
        switch (view) {
            case 'Formularios':
                if(productos.length > 0) dispatch(handleActiveModalQuitarTodo(true))
                break;
            case 'Previsualizacion':
                dispatch(handleChangeView('Formularios'))
                break;
            case 'Detalle':
                dispatch(docsAsociadosReset());
                dispatch(handleRestarFlujo())
                dispatch(handleRestartStateFormaPago())
                break;
        }
    }

    const footer_textButtons = () => {
        let textBack = ''
        let textNext = ''
        let iconBack = ''
        let iconNext = ''
        switch(view){
            case 'Formularios':
                textBack = 'Quitar todo'
                textNext = 'Siguiente'
                iconBack = ''
                iconNext = FlechaDerechaIcon
                break;
            case 'Previsualizacion':
                textBack = 'Anterior'
                textNext = 'Emitir'
                iconBack = ''
                iconNext = EmitirIcon
                break;
            case 'Detalle':
                textBack = ''
                textNext = 'Más opciones'
                iconBack = ''
                iconNext = MasOpcionesIcon
                break;
        }

        return {
            next: {
                text: textNext,
                icon: iconNext
            },
            back: {
                text: textBack,
                icon: iconBack
            }
        }
    }

    const button_onClickAsociarNotaRemision = () => {
        if(formCliente.noDocumento?.trim() !== '' && errorsCliente.noDocumento.trim() === '' && formCliente.nrc?.trim() !== '' && errorsCliente.nrc.trim() === ''){
            dispatch(handleActiveNotaRemision(true))
        } else {
            dispatch(generalOpenToastInfo('Ingresa el NIT y NRC del cliente'))
        }
    }

    const button_onClickAsociarClienteFeles = () => {
        dispatch(handleActiveClienteFeles(true))
    }

    const modal_button_cerrarClienteFeles = () => {
        dispatch(handleActiveClienteFeles(false))
    }

    const button_onClickQuitarTodo = () => {
        dispatch(handleAddProducto([]))
        modal_cerrarQuitarTodo()
        dispatch(generalOpenModalInfo('Se eliminaron todos los productos de la lista'))
    }

    const actionButton_editar = (producto: CFProducto, index: any) => {
        let tempForm: { [key: string]: any } = {
            ...productoEdit,
            ...producto
        }

        let errors: { [key: string]: string } = {};

        Object.keys(tempForm).forEach((key) => {
            if (validateFormProducto(key, tempForm[key])){
                let propiedad = key
                let value = validateFormProducto(key, tempForm[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormProducto({
            ...errors
        }))

        dispatch(handleSetIndexProductoEdit(index))
        dispatch(handleActiveModalEditar(true))
        dispatch(handleSetProductoEdit(producto))
    }

    const modal_cerrarModalEditar = () => {
        button_onClickLimpiarFormProducto()
        dispatch(handleSetIndexProductoEdit(null))
        dispatch(handleActiveModalEditar(false))
        dispatch(handleSetProductoEdit({
            ...productoEdit,
            descripcion: '',
            cantidad: '',
            precio: '',
            descuento: ''
        }))

    }

    const actionButton_eliminarProducto = (index: any) => {
        dispatch(handleSetIndexProductoEdit(index))
        dispatch(handleActiveModalEliminar(true))
    }

    const modal_button_onConfirmEliminar = () => {
        let tempArray = productos
        tempArray.splice(productoIndex, 1)
        dispatch(handleAddProducto(tempArray))
        dispatch(generalOpenModalInfo('Producto eliminado exitosamente.'))
        modal_cerrarModalEliminar()
    }

    const modal_cerrarModalEliminar = () => {
        dispatch(handleSetIndexProductoEdit(null))
        dispatch(handleActiveModalEliminar(false))
    }

    const modal_onChangeFormProductoEdit = (field: string, value: string) => {
        if(!validateChange(field, value) && value.trim() !== '') return

        dispatch(handleSetProductoEdit({
            ...productoEdit,
            [field] : value
        }))

        validateFormProductoEdit(field, value)
    }

    const modal_onChangeSelectCatalogoProductoEdit = (codeProduct: string) => {
        const newFormProductoEdit = processFormCatalogoProducto(dteCode, productoEdit, codeProduct)
        dispatch(handleSetProductoEdit({...productoEdit, ...newFormProductoEdit}))
    }

    const modal_button_onConfirmEdit = () => {
        dispatch(generalOpenConfirmEdit(action_onConfirmEdit))
    }

    const modal_button_cerrarNotaRemision = () => {
        dispatch(handleActiveNotaRemision(false))
    }

    const action_onConfirmEdit = () => {
        let errors: { [key: string]: string } = {};

        Object.keys(productoEdit).forEach((key) => {
            if (validateFormProducto(key, productoEdit[key])){
                let propiedad = key
                let value = validateFormProductoEdit(key, productoEdit[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            ...errors
        }))

        if(Object.values(errors).some((err) => err !== '')){
            dispatch(generalOpenModalInfo('Revisa los datos del producto'))
            return;
        }

        let tempArray = productos
        tempArray[productoIndex] = productoEdit
        dispatch(handleAddProducto(tempArray))
        modal_cerrarModalEditar()
        dispatch(generalOpenModalInfo('Producto actualizado exitosamente.'))
    }

    const modal_cerrarQuitarTodo = () => {
        dispatch(handleActiveModalQuitarTodo(false))
    }

    const modal_cerrarEmitir = () => {
        dispatch(handleActiveModalEmitir(false))
    }

    const modal_button_emitirNuevo = async() => {
        dispatch(handleAddProducto([]))
        dispatch(docsAsociadosReset());
        await dispatch(handleRestarFlujo())
        await dispatch(handleRestartStateFormaPago())
        await dispatch(handleSetFormCliente(
            {
                fecha: '',
                tipoDocumento: '',
                noDocumento: '',
                nombre: '',
                departamento: '',
                municipio: '',
                direccion: '',
                email: '',
                chipsEmail: [],
                telefono: '',
                actividad: '',
                actividadDescripcion: '',
                departamentoDescripcion: '',
                municipioDescripcion: '',
                nrc: '',

                datosSucursal: [],
                datosDocumento: [],

                sucursal: '',
                serie: '',
                loadedSucursal: false,
            }
        ))
        await dispatch(handleAddProducto([]))
        setTimeout(() => {
            dispatch(handleChangeView('Formularios'))
        }, 2)
        dispatch(handleAddProducto([]))
    }

    const guardarCliente = async() => {
        try {
            let body = {
                opcion: 2,
                tipoDocumento: formCliente.tipoDocumento || nitTipoDoc,
                numDocumento:  formCliente.noDocumento,
                nombre:  formCliente.nombre,
                direccion: formCliente.direccion,
                email: unirChipsJoin(formCliente.chipsEmail, formCliente.email),
                telefono:  formCliente.telefono,
                nrc:  formCliente.nrc,
                codActividad:  formCliente.actividad,
                descActividad:  actividadesEconomicas.find((actividad) => actividad.codigo === formCliente.actividad)?.valor,
                departamento: formCliente.departamento,
                municipio: formCliente.municipio,
            }
            const response: any = await api_buscarCliente(body)
            if (response){
                dispatch(generalOpenToastSuccess(response?.message || "Los datos del cliente han sido guardados satisfactoriamente."))
            }
        } catch (error: any) {
            dispatch(generalOpenToastError(error?.response?.data?.message || 'Se produjo un error al guardar la información del cliente.', "Alerta"))
        }
    }

    const buscarCliente = async() => {
        if(formCliente.noDocumento && (validateFormCliente('noDocumento', formCliente.noDocumento) === '')){
            // dispatch(generalShowLoader(true))
            try {
                let body = {
                    opcion: '1',
                    tipoDocumento: nitTipoDoc,
                    numDocumento: formCliente.noDocumento
                }

                const user: any = await api_buscarCliente(body)

                if(user?.body !== null) {
                    if (user?.body?.notificarcorreo?.length > 0) { dispatch(generalOpenModalInfo(getEmailNotifyMsg(user.body.notificarcorreo))); }
                    dispatch(handleSetInfoClienteEncontrado(user.body))
                    dispatch(handleActiveModalClienteEncontrado(true))
                } else {
                    dispatch(generalOpenToastInfo('El cliente es nuevo y será registrado al finalizar la factura, para llenarlo automáticamente en un nuevo documento.', 'Aviso'))
                    dispatch(handleSetInfoClienteEncontrado(null))
                }

            } catch (err: any) {
                dispatch(generalOpenToastError(err?.response?.data?.message || 'Se produjo un error al buscar la información del cliente.', "Alerta"))
            } finally {
                // dispatch(generalShowLoader(false))
            }
        }
    }

    const modal_button_verDetalle = () => {
        dispatch(handleChangeView('Detalle'))
        dispatch(handleActiveModalEmitido(false))
        modal_cerrarEmitir()
    }

    const modal_cerrarMasOpciones = () => {
        dispatch(handleActiveModalMasOpciones(false))
        dispatch(handleActiveModalEmitido(false))
    }

    const modal_button_cerrarModalEmitido = () => {
        dispatch(handleRestarFlujo())
        dispatch(handleRestartStateFormaPago())
        dispatch(docsAsociadosReset());
        dispatch(handleAddProducto([]))
        dispatch(handleActiveModalEmitido(false))
        history.push('/otros-documentos')
    }

    const modal_button_enviarCorreo = () => {
        dispatch(handleActiveModalCorreo(true))
    }

    const modal_button_cerrarEnviarCorreo = () => {
        dispatch(handleActiveModalCorreo(false))
    }

    const modal_button_descargarExcel = async() => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getExcelFactura(
                {
                    Documento: response_Emitir.JsonFactura,
                    Sello: response_Emitir.Sello,
                },
                response_Emitir.codigoGeneracion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar el Excel.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_descargarImagen = async() => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getFacturaImage(
                {
                    Documento: response_Emitir.JsonFactura,
                    Sello: response_Emitir.Sello,
                },
                response_Emitir.codigoGeneracion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar la imagen.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_descargarPDF = async() => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getFacturaPDF_New(
                {
                    Documento: response_Emitir.JsonFactura,
                    Sello: response_Emitir.Sello,
                },
                response_Emitir.serie,
                response_Emitir.estadoanulacion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar el PDF.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_imprimir = () => {
        dispatch(handleActiveModalImprimir(true))
    }

    const modal_cerrarImprimir = () => {
        dispatch(handleActiveModalImprimir(false))
    }

    const modal_button_onClickEnviarCorreo = async(email: string) => {
        const sendEmail: OPSendEmail = {
            Correo: email,
            Sello: response_Emitir.Sello,
            IdSucursalDoc: formCliente.serie || "-1",
            idSucursal: datos?.sucursal_seleccionada,
            idEmpresa: `${datos?.codigo_empresa}`
        }
        const res:any = await dispatch(sendEmailPDF(sendEmail))
        if (res) {
            dispatch(generalOpenModalMessage('Enviar por correo electrónico', 'El correo electrónico fue enviado exitosamente.'))
        }
    }

    const modal_button_descargarJson = () => dispatch(descargarJson({idFactura: response_Emitir?.codigoGeneracion, json: response_Emitir?.JsonFacturaFile}))   

    const modal_button_anular = () => {
        dispatch(handleActiveModalAnular(true))
    }

    const modal_cerrarAnular = () => {
        dispatch(handleActiveModalAnular(false))
    }

    const modal_cerrarClienteEncontrado = () => {
        dispatch(handleActiveModalClienteEncontrado(false))
    }

    const modal_button_aceptarClienteEncontrado = async() => {
        let tempForm: { [key: string]: any } = {
            ...formCliente,
            nombre: clienteEncontrado.nombre,
            tipoDocumento: clienteEncontrado.tipoDocumento,
            noDocumento: clienteEncontrado.numDocumento,
            direccion: clienteEncontrado.direccion,
            email: '',
            chipsEmail: clienteEncontrado.email.split(','),
            telefono: clienteEncontrado.telefono,
            nrc: clienteEncontrado.nrc,
            actividad: clienteEncontrado.codActividad,
            departamento: clienteEncontrado.departamento,
            municipio: clienteEncontrado.municipio
        }

        let errors: { [key: string]: string } = {};

        Object.keys(tempForm).forEach((key) => {
            if (validateFormCliente(key, tempForm[key]) && key !== "email"){
                let propiedad = key
                let value = validateFormCliente(key, tempForm[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormCliente({
            ...errorsCliente,
            ...errors
        }))

        dispatch(handleSetFormCliente(tempForm))
        modal_cerrarClienteEncontrado()
    }

    const modal_button_onConfirmAnular = async() => {
        dispatch(generalShowLoader(true))

        try {
            //------------------------
            let documento = formCliente?.datosSucursal?.find((sucursal: any) => sucursal?.idsucursal === formCliente?.sucursal)?.Documento?.find((doc: any) => doc?.idsucursaldocumento === formCliente?.serie)
            let serie = `${documento?.serie}-${documento?.numeroactual}`
            let ivaTotal = 0
            productos.forEach((producto) => {
                let precioUnitario = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
                let ivaProducto = (precioUnitario * 0.13) * parseFloat(producto.cantidad)
                if(!producto.exento){
                    ivaTotal += ivaProducto
                }
            })
            //------------------------
            const anularDoc = {
                documento: response_Emitir.JsonFactura,
                sellorecibido: response_Emitir.Sello,
                DetallesDTE: {
                    receptor: {
                        numDocumento: formCliente.noDocumento,
                        tipoDocumento: formCliente.tipoDocumento || nitTipoDoc,
                        nrc: formCliente.nrc,
                        nombre: formCliente.nombre?.trim(),
                        telefono: formCliente.telefono?.trim(),
                        correo: unirChipsReturnFirst(formCliente.chipsEmail, formCliente.email),
                    },
                    emisor: {
                        nombre: datosEmisor.nombre,
                        nit: datosEmisor.nit,
                        nrc: datosEmisor.nrc,
                        telefono: datosEmisor.telefono,
                        correo: datosEmisor.correo,
                        tipoEstablecimiento: datosEmisor.tipoestablecimiento,
                    },
                    resumen: {
                        totalIva: isNaN(ivaTotal) ? '0' : `${ivaTotal.toFixed(getDigitosCalculables(datos?.codigo_empresa))}`,
                    },
                    identificacion: {
                        tipoDte: '03',
                        codigoGeneracion: response_Emitir.codigoGeneracion,
                        numeroControl: `DTE-03-${serie}`,
                        fecEmi: convertDateFormatAnular(response_Emitir.fhProcesamiento.split(' ')[0]),
                        IDsucursalDoc: documento.idsucursaldocumento
                    },
                },
            }
            const response: any = await dispatch(anularFactura_DTE(anularDoc))
            if(response){
                dispatch(generalOpenModalInfo('Documento anulado exitosamente'))
                modal_button_emitirNuevo()
            }


        } catch (error: any) {
            dispatch(generalOpenModalError(error?.response?.data?.body?.descripcionMsg || 'Ocurrió un error al anular el documento.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_emitirDocumento = async() => {
        dispatch(generalShowLoader(true))
        const horasActuales:any = await dispatch(getFechaHora());
        try{
            guardarCliente()
            //CALCULAR DESCUENTO TOTAL 
            let descuentoTotal = 0
            productos.forEach((producto) => {
                let descuento =
                    producto.tipoDescuento === 'Porcentaje' ?
                        (parseFloat(producto.descuento || '0')/100 * (producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio))) * parseFloat(producto.cantidad) :
                        parseFloat(producto.descuento || '0')

                descuentoTotal += descuento
            })

            let documento = formCliente?.datosSucursal?.find((sucursal: any) => sucursal?.idsucursal === formCliente?.sucursal)?.Documento?.find((doc: any) => doc?.idsucursaldocumento === formCliente?.serie)
            let serie = `${documento?.serie}-${documento?.numeroactual}`

            let body: any = {
                id_user: localStorage.getItem(KEYS.ID_CLIENT),
                tipoContribuyente_receptor: formCliente.granContribuyente,
                facturas:
                    [{
                        receptorManual: datosReceptor.nombre,
                        docManual: datosReceptor.numId,
                    esReceptorManual : datosReceptor.esReceptorManual,
                    tipoDocManual : datosReceptor.nombreTipoDocumento,
                        idsucursaldocumento: formCliente.serie,
                        receptorEmailsEnvio: unirChipsJoin(formCliente.chipsEmail, formCliente.email),
                    tipoDte:"03",
                        cveDoc: serie,
                        uuid: datosUUID?.CodigoGeneracion,
                        fechaDoc: horasActuales ? (`${horasActuales.FechaDDMM} ${horasActuales.Hora}`) : `${getFechaFormato1()} ${new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}`,
                        canTotal: `${(
                            calculosProductos().sumaOperaciones +
                            (
                                propinaConfig?.propina_activa === true &&
                                    formCliente?.propina === true &&
                                    (parseFloat(propinaConfig?.cantidad_propina) || 0) > 0
                                    ? calculosProductos().sumaOperaciones * parseFloat(propinaConfig.cantidad_propina)
                                    : 0
                            )
                        ).toFixed(getDigitosCalculables(datos?.codigo_empresa))
                            }`,
                        impuTotal: `${calculosProductos().iva.toFixed(2)}`, //Hacienda solo soporta 2 decimales en IVA
                        impuTotal2: `${calculosProductos().ivaRetenido.toFixed(2)}`,
                        impuTotal3: `${calculosProductos().ivaPercibido.toFixed(2)}`,
                        descuentoTotal: `${descuentoTotal.toFixed(getDigitosCalculables(datos?.codigo_empresa))}`,
                        retencionRenta: `${quitarRetencionRenta ? '0' : calculosProductos().retencionRenta.toFixed(2)}`,
                        condicionOperacion: formFormaPago.condicion,
                        formapago: pagos.map((pago) => {
                            return (
                                {
                                    codigo: pago.formaPago,
                                    descripcion: pago.descripcion,
                                    montoPago: parseFloat(pago.monto).toFixed(getDigitosCalculables(datos?.codigo_empresa)),
                                    referencia: pago.numeroDocumento || '',
                                    plazo: pago.plazo,
                                    periodo: pago.periodo
                                }
                            )
                        }),
                        cuerpoDocumento: [
                            ...productos.map((producto) => {
                                let precioConIVA = parseFloat(producto.precio) / 1.13;
                                let precioSinIVA = parseFloat(producto.precio);
                                let precioUni = producto.conIva ? precioConIVA : precioSinIVA;
                                let impuestoItem = 0;
                                let ivaPercibido = 0;
                                let ivaRetenido = 0;

                                let descuento =
                                    producto.tipoDescuento === "Porcentaje"
                                        ? (parseFloat(producto.descuento || "0") / 100 *
                                            (producto.conIva ? parseFloat(producto.precio) / 1.13 : parseFloat(producto.precio))) *
                                        parseFloat(producto.cantidad)
                                        : parseFloat(producto.descuento || "0");

                                let precio = parseFloat(producto.precio) * parseFloat(producto.cantidad) - descuento;

                                if (!producto.exento && emisorJuridico) {
                                    impuestoItem += precio * 0.13;

                                    if (emisorGranContribuyente && emisorJuridico && !formCliente.granContribuyente && precio >= 100) {
                                        ivaPercibido += precio * 0.01;
                                    }

                                    if (!emisorGranContribuyente && formCliente.granContribuyente && precio >= 100) {
                                        ivaRetenido += precio * 0.01;
                                    }
                                }

                                return {
                                    cantidad: `${parseFloat(producto.cantidad).toFixed(getDigitosCalculables(datos?.codigo_empresa))}`,
                                    precioUni: `${precioUni}`,
                                    impuesoItem: `${impuestoItem.toFixed(getDigitosCalculables(datos?.codigo_empresa))}`,
                                    impuesoItem2: `${ivaRetenido.toFixed(getDigitosCalculables(datos?.codigo_empresa))}`,
                                    impuesoItem3: `${ivaPercibido.toFixed(getDigitosCalculables(datos?.codigo_empresa))}`,
                                    impuesto: producto.exento ? "0" : "13",
                                    impuesto2: producto.exento ? "0" : ivaRetenido > 0 ? "1" : "0",
                                    impuesto3: producto.exento ? "0" : ivaPercibido > 0 ? "1" : "0",
                                    descripcion: producto.descripcion,
                                    descuento: isNaN(descuento)
                                        ? "0"
                                        : `${descuento.toFixed(getDigitosCalculables(datos?.codigo_empresa))}`,
                                    TipoMonto: producto.exento ? "1" : "0",
                                    IncluyeIva: producto.conIva ? "1" : "0",
                                    TipoItem: producto.servicio ? "0" : "1",
                                    descUnidad: unidadesMedida.find((unidad) => unidad.codigo === producto.unidadMedida)?.valor,
                                    unidad: producto.unidadMedida,
                                    numeroDocumento: producto.notaRemisionId ? producto.notaRemisionId : null,
                                    tributos: producto.tributos ?? [],
                                    codigo: producto.clave ?? "",
                                };
                            }),

                            ...(propinaConfig?.propina_activa === true && formCliente?.propina === true
                                ? [{
                                    cantidad: "1",
                                    precioUni: "0",
                                    descuento: "0",
                                    impuesto: "0",
                                    impuesto2: "0",
                                    impuesto3: "0",
                                    descripcion: "no gravado",
                                    TipoMonto: "3",
                                    IncluyeIva: "1",
                                    TipoItem: "1",
                                    unidad: "59",
                                    descUnidad: "UNIDAD",
                                    numeroDocumento: null,
                                    tributos: [],
                                    noGravado: `${(
                                            calculosProductos().sumaOperaciones *
                                            parseFloat(propinaConfig.cantidad_propina || 0)
                                        ).toFixed(getDigitosCalculables(datos?.codigo_empresa))
                                        }`,
                                    codigo: ""
                                }]
                                : [])
                        ],

                        docRelacionado: notasRemisionAsociadas.map((doc) => ({
                            tipoGeneracion: 2,
                            tipoDocumento: '04',
                            numeroDocumento: doc?.codigogeneracion,
                            numeroDocumentoDte: doc?.CorrelativoSuscripcion,
                            fechaEmision: doc?.DetallesDTE?.identificacion?.fecEmi,
                            tipoDocRelDesc: 'Nota de remisión',
                            fechaDocRel: `${doc?.DetallesDTE?.identificacion?.fecEmi?.split('-')[2]}/${doc?.DetallesDTE?.identificacion?.fecEmi?.split('-')[1]}/${doc?.DetallesDTE?.identificacion?.fecEmi?.split('-')[0]}`
                        })),
                        receptor: {
                            nombre: formCliente.nombre,
                            direccion: formCliente.direccion,
                            email: unirChipsReturnFirst(formCliente.chipsEmail, formCliente.email),
                            telefono: formCliente.telefono,
                            nit: formCliente.noDocumento,
                            nrc: formCliente.nrc,
                            codActividad: formCliente.actividad,
                            descAtvividad: actividadesEconomicas.find((actividad) => actividad.codigo === formCliente.actividad)?.valor,
                            departamento: formCliente.departamento,
                            municipio: formCliente.municipio,
                        },
                    otrosDocumentos: dataDocsAsociados.map((doc:any) => ({
                            detalleDocumento: doc.descripcion,
                            descDocumento: doc.identificacion,
                            codDocAsociado: parseInt(doc.tipo),
                            descCodDocAsociado: `${doc.tipo}-${docsAsociadosItems.find((tipo) => tipo.codigo === doc.tipo)?.valor}`
                        })),
                        tributos: calculosProductos().resumenTributos,
                    }],
                tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
                tokenHacienda: localStorage.getItem(KEYS.HACIENDA) ?? '',
                pagoFeles: {
                    esClienteFeles: formClienteFeles.tipoTransaccion !== "00" && datos.socio,
                    tipoTransaccion: formClienteFeles.tipoTransaccion !== "00" ? formClienteFeles.tipoTransaccion : "",
                    valorTransaccion: formClienteFeles.valorTransaccion,
                    comprobante: {
                        descripcion: tipoCargosMembresia.find((tc) => tc.codigo === formClienteFeles.tipoTransaccion)?.valor || '',
                        archivo64: localStorage.getItem(KEYS.COMPROBANTE) ?? '',
                        idBanco: formClienteFeles.idBanco ? formClienteFeles.idBanco : 0,
                        numAutorizacion: formClienteFeles.numAutorizacion,
                    }
                },
                idSucursal: datos?.sucursal_seleccionada,
                idEmpresa: `${datos?.codigo_empresa}`
            }

            const response: any = await api_RecepcionDTE(body)
                if(response.body.estado === 'PROCESADO'){
                    if(response?.body?.NuevoToken){
                    localStorage.setItem(KEYS.HACIENDA, response?.body?.TokenHacienda)
                }
                dispatch(handleSetResponseEmitir(response.body))
                dispatch(handleActiveModalEmitido(true))
                dispatch(handleActiveModalEmitir(false))
                dispatch(handleChangeView('Detalle'))
                const qrResponse = await getQR(response.body.JsonFactura)
                  if(qrResponse.qr){
                    let qrString = generateQRImageFromBits(qrResponse.qr?.replace("data:image/jpeg;base64,", ""))
                    dispatch(handleSetQRCode(qrString))
                } else {
                    dispatch(generalOpenModalError(qrResponse.message || 'Ocurrió un error al obtener el código QR'))
                }
            }

        } catch (err: any) {
            let message = 'Ocurrió un error al emitir el crédito fiscal, contacta al administrador.'

            if(err.response.data.message) message = err.response.data.message
            else {
                try{
                    let messageDesc = err?.response?.data?.body?.descripcionMsg?.replace(/\[(\w+)\.(\w+)\]\s(\w+)/, '$2 de $1 : $3').toUpperCase()
                    message = messageDesc || message
                } catch {
                    message = 'Ocurrió un error al emitir el crédito fiscal, contacta al administrador.'
                }
            }

            dispatch(generalOpenModalError(message))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const roundTo = (n: number, digits: number) => {
        if (digits === undefined) {
            digits = 0;
        }

        var multiplicator = Math.pow(10, digits);
        n = parseFloat((n * multiplicator).toFixed(11));
        return Math.round(n) / multiplicator;
    }


    const calculosProductos = () => {
        let sumaOperaciones = 0
        let iva = 0
        let subtotal = 0
        let ivaPercibido = 0
        let ivaRetenido = 0
        let retencionRenta = 0
        let total = 0
        let otrosImpuestos = 0
        let resumenTributos:Array<any> = [];
        let digitos = getDigitosCalculables(datos?.codigo_empresa)

        productos.forEach((producto) => {
            let descuento =
                producto.tipoDescuento === 'Porcentaje' ?
                (parseFloat(producto.descuento || '0')/100 * (producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio))) * parseFloat(producto.cantidad) :
                    parseFloat(producto.descuento || '0')

            let precioConIVA = ((parseFloat(producto.precio)/1.13)) * parseFloat(producto.cantidad) - descuento
            let precioSinIVA = (parseFloat(producto.precio)) * parseFloat(producto.cantidad) - descuento
            let precio = producto.conIva ? precioConIVA : precioSinIVA

            if(!producto.exento) iva += (precio * 0.13)

            if(!producto.exento && emisorJuridico){
                if(emisorGranContribuyente && emisorJuridico && !formCliente.granContribuyente){
                    ivaPercibido += roundTo((precio*0.01), 2)
                }
            }

            if(!producto.exento){
                if(!emisorGranContribuyente && formCliente.granContribuyente){
                    ivaRetenido += roundTo((precio*0.01), 2)
                }
            }
            /* se comento por cambios de Hacienda art 145 codigo tributario */
            // if(producto.servicio && !emisorGranContribuyente && !emisorJuridico &&!quitarRetencionRenta){
            //     retencionRenta += roundTo((precio*0.1), 2)
            // }

            sumaOperaciones += precio
            otrosImpuestos += processOtrosImpuestosCalculo(dteCode, producto, precio, false);
            resumenTributos = procesOtrosImpuestosResumen(dteCode, resumenTributos, producto, precio);
        })

        resumenTributos.forEach((resum) => {
            resum.valor = parseFloat(resum.valor.toFixed(getDigitosCalculables(datos?.codigo_empresa)));
        });


        if(sumaOperaciones < 100 && (ivaPercibido > 0 || ivaRetenido > 0)) {
            ivaRetenido = 0;
            ivaPercibido = 0;
        }
        iva = roundTo(iva, 2)
        sumaOperaciones = roundTo(sumaOperaciones, 2)
        subtotal = sumaOperaciones + iva + otrosImpuestos;
        total = roundTo(subtotal + ivaPercibido - ivaRetenido - retencionRenta, 2)
        // Calculo propina
        if (formCliente.propina && propinaConfig?.propina_activa) {
            // propina = sumaOperaciones * porcentaje
            const montoPropina = roundTo(sumaOperaciones * (propinaConfig.cantidad_propina || 0), 2);
            total = roundTo(total + montoPropina, 2);
        }

        return {
            sumaOperaciones: sumaOperaciones,
            iva: iva,
            subtotal: subtotal,
            ivaPercibido: ivaPercibido,
            ivaRetenido: ivaRetenido,
            retencionRenta: retencionRenta,
            otrosImpuestos: otrosImpuestos,
            resumenTributos: resumenTributos,
            total: total,
        }
    }

    const actionButton_desasociarNotaRemision = (numeroControl: any) => {
        let tempArray = productos.filter((producto) => producto.notaRemisionId !== numeroControl)
        let arrayNR = notasRemisionAsociadas.filter((nota) => nota.codigogeneracion !== numeroControl)
        dispatch(handleAddProducto(tempArray))
        dispatch(handleSetNotasRemisionAsociadas(arrayNR))
    }

    const actionButton_asociarNotaRemision = (productosNR: any, numeroControl: any, notaRemision: any) => {
        let arrayNR = notasRemisionAsociadas
        let tempArray = productos
        productosNR.forEach((prod: any) => {
            let ventasExentas = prod.ventaExenta + prod.ventaNoSuj

            tempArray.push({
                notaRemisionId: numeroControl,
                conIva: false,
                descripcion: prod.descripcion,
                cantidad: prod.cantidad.toFixed(getDigitosCalculables(datos?.codigo_empresa)),
                precio: prod.precioUni.toFixed(getDigitosCalculables(datos?.codigo_empresa)),
                tipoDescuento: 'Monto',
                descuento: prod.montoDescu.toFixed(getDigitosCalculables(datos?.codigo_empresa)),
                servicio: prod.tipoItem === 2,
                exento: ventasExentas > 0,
                unidadMedida: `${prod.uniMedida}`
            })
        })
        arrayNR.push(notaRemision)

        dispatch(handleSetNotasRemisionAsociadas(arrayNR))
        dispatch(handleAddProducto(productos))
    }

    const buscarNotasRemision = async() => {
        try {
            dispatch(handleActiveLoaderNotaRemision(true))

            let docsValidosCliente = notasRemisionAsociadas.filter((doc: any) => doc?.DetallesDTE?.receptor?.numDocumento === formCliente.noDocumento)
            dispatch(handleSetNotasRemisionAsociadas(docsValidosCliente))
            let productosValidos = productos.filter((doc: any) => !doc.notaRemisionId || docsValidosCliente.some((nota: any) => nota.codigogeneracion === doc.notaRemisionId))
            dispatch(handleAddProducto(productosValidos))

            let fechaHoy = new Date().toISOString().split('T')[0];
            let fechaInicio = new Date(fechaHoy);
            fechaInicio.setDate(fechaInicio.getDate() - 30);

            const año = fechaInicio.getFullYear();
            const mes = (fechaInicio.getMonth() + 1).toString().padStart(2, '0');
            const dia = fechaInicio.getDate().toString().padStart(2, '0');
            const fechaHaceTreintaDias = `${año}-${mes}-${dia}`;

            let body = {
                fechaInicio: fechaHaceTreintaDias,
                fechaFin: fechaHoy,
                tipoDoc: nitTipoDoc,
                nit_emisor: datosEmisor.nit,
                nrc_receptor: formCliente.nrc ?? "-1",
                nrc_emisor: datosEmisor.nrc,
                doc_receptor: formCliente.noDocumento,
                tipodte: "04",
                NombreCompleto: formCliente.nombre ?? "-1",
                offset: 0,
                tokenGateway: localStorage.getItem(KEYS.TOKEN),
            }

            const response: any = await api_buscarDocumentos(body)
            let documentosValidos = response.body.filter((doc: any) => !doc.DetallesDTE.documentoRelacionado)
            dispatch(handleSetNotasRemisionEncontradas(documentosValidos))
        } catch (error: any) {
            dispatch(handleSetNotasRemisionEncontradas([]))
        } finally {
            dispatch(handleActiveLoaderNotaRemision(false))
        }
    }

    const modal_button_anular2 = async () => {
        let documento = formCliente?.datosSucursal?.find((sucursal: any) => sucursal?.idsucursal === formCliente?.sucursal)?.Documento?.find((doc: any) => doc?.idsucursaldocumento === formCliente?.serie)
        let serie = `${documento?.serie}-${documento?.numeroactual}`
        let ivaTotal = 0
        productos.forEach((producto) => {
            let precioUnitario = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
            let ivaProducto = (precioUnitario * 0.13) * parseFloat(producto.cantidad)
            if(!producto.exento){
                ivaTotal += ivaProducto
            }
        })
        const anularDoc: any = {
            documento: response_Emitir.JsonFactura,
            sellorecibido: response_Emitir.Sello,
            DetallesDTE: {
                receptor: {
                    numDocumento: formCliente.noDocumento,
                    tipoDocumento: formCliente.tipoDocumento || nitTipoDoc,
                    nrc: formCliente.nrc,
                    nombre: formCliente.nombre,
                    telefono: formCliente.telefono,
                    correo: unirChipsReturnFirst(formCliente.chipsEmail, formCliente.email),
                },
                emisor: {
                    nombre: datosEmisor.nombre,
                    nit: datosEmisor.nit,
                    nrc: datosEmisor.nrc,
                    telefono: datosEmisor.telefono,
                    correo: datosEmisor.correo,
                    tipoEstablecimiento: datosEmisor.tipoestablecimiento,
                },
                resumen: {
                    totalIva: ivaTotal,
                },
                identificacion: {
                    tipoDte: '03',
                    codigoGeneracion: response_Emitir.codigoGeneracion,
                    numeroControl: `DTE-03-${serie}`,
                    fecEmi: convertDateFormatAnular(response_Emitir.fhProcesamiento.split(' ')[0]),
                },
            },
        }
        dispatch(anularFactura([anularDoc]))
    }

    const setTableProductos = (table: any) => {
        dispatch(handleSetTableProductos(table))
    }

    const handleChangeRetencionRenta = () => {
        dispatch(handleActiveRetencionRenta(!quitarRetencionRenta))
    }

    useEffect(() => {
        let digitos = getDigitosCalculables(datos?.codigo_empresa)
        let precioConIVA = (parseFloat(formProducto.precio)/1.13)
        let precioSinIVA = (parseFloat(formProducto.precio))
        let precioUnitario = formProducto.conIva ? precioConIVA : precioSinIVA
        let descuento = 0
        if(formProducto.tipoDescuento === 'Porcentaje'){
            descuento = isNaN(parseFloat(formProducto.descuento)) ? 0 : (precioUnitario * parseFloat(formProducto.descuento)/100) * parseFloat(formProducto.cantidad)
        } else {
            descuento = isNaN(parseFloat(formProducto.descuento)) ? 0 : parseFloat(formProducto.descuento)
        }
        let neto = (parseFloat(formProducto.cantidad) * precioUnitario)
        let subtotal = neto - descuento
        let iva = subtotal * 0.13
        let otrosImpuestos = processOtrosImpuestosCalculo(dteCode, formProducto, subtotal);

        if(formProducto.exento) iva = 0
        let total = subtotal + iva;

        dispatch(handleCalculosProducto({
            neto: isNaN(neto) ? '$0.00' : formatearNum(neto),
            subtotal: isNaN(subtotal) ? '$0.00' : formatearNum(subtotal),
            descuento: isNaN(descuento) ? '$0.00' : formatearNum(descuento),
            total: isNaN(total) ? '$0.00' : formatearNum(total),
            iva: isNaN(iva) ? '$0.00' : formatearNum(iva),
            otrosImpuestos: isNaN(otrosImpuestos) ? '$0.00' : formatearNum(otrosImpuestos),
        }))

    }, [formProducto])

    useEffect(() => {
        if(formProducto.exento){
            dispatch(handleSetFormProducto({
                ...formProducto,
                conIva: false,
            }))
        }
    }, [formProducto.exento])

    useEffect(() => {
        if(formProducto.conIva){
            dispatch(handleSetFormProducto({
                ...formProducto,
                exento: false,
            }))
        }
    }, [formProducto.conIva])

    useEffect(() => {
        if(formCliente.tipoDocumento && formCliente.tipoDocumento !== '') validateFormCliente('noDocumento', formCliente.noDocumento)
    }, [formCliente.tipoDocumento])

    useEffect(() => {
        if(Array.isArray(formCliente.datosSucursal) && formCliente.datosSucursal.length > 0) cargarDatosIniciales()
        else if (formCliente.loadedSucursal) {
            dispatch(showMessageSucursalVacia('Comprobante de crédito fiscal'));
            history.push('/home');
            dispatch(handleRestarFlujo());
        }
    }, [formCliente.datosSucursal, formCliente.loadedSucursal])

    useEffect(() => {
        if(formProducto.descuento){
            validateFormProducto('descuento', formProducto.descuento)
        }
    }, [formProducto])

    useEffect(() => {
        if(productoEdit.descuento){
            validateFormProductoEdit('descuento', productoEdit.descuento)
        }
    }, [productoEdit])

    useEffect(() => {
        let tempArray = notasRemisionAsociadas
        notasRemisionAsociadas.forEach((nota) => {
            if(!productos.some((producto) => producto.notaRemisionId === nota.codigogeneracion)){
                tempArray = tempArray.filter((n) => n.codigogeneracion !== nota.codigogeneracion)
            }
        })

        dispatch(handleSetNotasRemisionAsociadas(tempArray))
    }, [productos.length])

    return {
        cargarSucursales,
        cargarDatosIniciales,
        buscarCliente,
        buscarNotasRemision,

        onChangeFormCliente,
        onChangeFormProducto,
        onChangeFormClienteFeles,
        onChangeSelectCatalogoProducto,

        validateFormCliente,
        validateFormProducto,
        setErrorsFormClienteFeles,

        button_onClickAgregarProducto,
        button_onClickLimpiarFormProducto,
        button_onClickQuitarTodo,
        button_onClickAsociarNotaRemision,
        button_onClickAsociarClienteFeles,

        footer_onClickBack,
        footer_onClickNext,
        footer_textButtons,

        actionButton_editar,
        actionButton_eliminarProducto,
        actionButton_asociarNotaRemision,
        actionButton_desasociarNotaRemision,

        modal_cerrarQuitarTodo,
        modal_cerrarModalEditar,
        modal_cerrarModalEliminar,
        modal_cerrarEmitir,
        modal_cerrarMasOpciones,
        modal_cerrarImprimir,
        modal_cerrarAnular,
        modal_cerrarClienteEncontrado,
        
        modal_button_cerrarClienteFeles,
        modal_button_cerrarNotaRemision,
        modal_button_onConfirmEdit,
        modal_button_onConfirmEliminar,
        modal_button_emitirDocumento,
        modal_button_emitirNuevo,
        modal_button_verDetalle,
        modal_button_cerrarModalEmitido,    
        modal_button_enviarCorreo,
        modal_button_cerrarEnviarCorreo,
        modal_button_onClickEnviarCorreo,
        modal_button_descargarExcel,
        modal_button_descargarImagen,
        modal_button_descargarPDF,
        modal_button_imprimir,
        modal_button_anular,
        modal_button_onConfirmAnular,
        modal_button_aceptarClienteEncontrado,
        modal_button_anular2,
        modal_button_descargarJson,

        modal_onChangeFormProductoEdit,
        modal_onChangeSelectCatalogoProductoEdit,
        setTableProductos,
        calculosProductos,
        handleChangeRetencionRenta
    }
}

const handleSetFormCliente = (form: any):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_SET_FORM_CLIENTE, payload: form})
const handleSetFormClienteFeles = (form: any):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_SET_FORM_CLIENTE_FELES, payload: form})
const handleSetFormProducto = (form: any):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_SET_FORM_PRODUCTO, payload: form})
const handleErrorsFormCliente = (errors: any):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_HANDLE_ERRORS_CLIENTE, payload:errors})
const handleErrorsFormProducto = (errors: any):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_HANDLE_ERRORS_PRODUCTO, payload:errors})
const handleErrorsFormClienteFeles = (errors: any):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_HANDLE_ERRORS_CLIENTE_FELES, payload:errors})

const handleCalculosProducto = (calculos: any):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_SET_CALCULOS_PRODUCTO, payload: calculos})
const handleAddProducto = (productos: any):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_SET_PRODUCTOS, payload: productos})
const handleRestartFormProducto = ():ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_RESTART_FORM_PRODUCTO, payload: null})
const handleChangeView = (view: string):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_SET_VIEW, payload: view})
const handleActiveModalQuitarTodo = (active: boolean):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_QUITAR_TODO, payload: active})
const handleActiveModalEditar = (active: boolean):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_EDITAR_PRODUCTO, payload: active})
const handleActiveModalEliminar = (active: boolean):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_ELIMINAR_PRODUCTO, payload: active})
const handleActiveModalEmitir = (active: boolean):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_EMITIR, payload: active})
const handleActiveModalEmitido = (active: boolean):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_EMITIDO, payload: active})
const handleActiveModalMasOpciones = (active: boolean):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_MAS_OPCIONES, payload: active})
const handleActiveModalCorreo = (active: boolean):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_ENVIAR_CORREO, payload: active})
const handleActiveModalImprimir = (active: boolean):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_IMPRIMIR, payload: active})
const handleActiveModalClienteEncontrado = (active: boolean):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_CLIENTE_ENCONTRADO, payload: active})
const handleActiveModalAnular = (active: boolean):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_ANULAR, payload: active})
const handleActiveModalAnulado = (active: boolean):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_ANULADO, payload: active})
const handleSetProductoEdit = (producto: any):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_SET_PRODUCTO_EDIT, payload: producto})
const handleSetIndexProductoEdit = (index: any):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_SET_PRODUCTO_INDEX, payload: index})
const handleSetResponseEmitir = (response: any):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_SET_RESPONSE_EMITIR, payload: response})
const handleSetQRCode = (qr: any):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_SET_QR_CODE, payload: qr})
export const handleRestarFlujo = ():ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_RESTART_ALL, payload: true})
const handleSetInfoClienteEncontrado = (info: any):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_SET_CLIENTE_ENCONTRADO, payload: info})
const handleSetTableProductos = (table: any):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_SET_TABLE_PRODUCTOS, payload: table})
const handleActiveRetencionRenta = (active: boolean):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_SET_RETENCION_RENTA, payload: active})
const handleActiveNotaRemision = (active: boolean):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_ACTIVE_NOTA_REMISION, payload: active})
const handleActiveLoaderNotaRemision = (active: boolean):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_ACTIVE_LOADER_NOTAS_REMISION, payload: active})
const handleSetNotasRemisionEncontradas = (notas: Array<any>):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_NOTAS_REMISION_ENCONTRADAS, payload: notas})
const handleSetNotasRemisionAsociadas = (notas: Array<any>):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_NOTAS_REMISION_ASOCIADAS, payload: notas})

const handleActiveClienteFeles = (active: boolean):ActionCF => ({type: CREDITO_FISCAL_TYPES.CCF_ACTIVE_ASOCIAR_FELES, payload: active})

const api_getSucursales = (body: any) => http.post(ENDPOINTS.GESTION_USUARIO_POST_SUCURSALES, body, {}, KEYS.TOKEN)
const api_RecepcionDTE = (body: any) => http.post(ENDPOINTS.FACTURACION_POST_RECEPCION_DTE, body, {}, KEYS.TOKEN)
const api_buscarCliente = (body: any) => http.post(ENDPOINTS.CLIENTE_RECEPTOR_GUARDAR, body,  {}, KEYS.TOKEN)
const api_buscarDocumentos = (body: any) => http.post(ENDPOINTS.GET_HISTORIAL_TRANSACCIONES, body, {}, KEYS.TOKEN) 